import { PLAY, STOP } from "../actions/PlayerActions";

const initialState = {
  isPlaying: false,
};

const playerReducer = (state = initialState, action) => {
  switch (action.type) {
    case PLAY:
      return {
        ...state,
        isPlaying: true,
      };
    case STOP:
      return {
        ...state,
        isPlaying: false,
      };
    default:
      return state;
  }
};

export default playerReducer;